export default {
  "hierarchy": {
    "comparator": [
      "dateTimePicker-comparator"
    ],
    "attributeTableTimestampEditor": [
      "dateTimePicker-attributeTableTimestampEditor"
    ]
  },
  "props": {
    "default": {
      "calendarIcon": "fak fa-lv-calendar",
      "calendarButtonVariant": "link",
      "clearButtonVariant": "link"
    },
    "comparator": {
      "calendarIcon": "fak fa-lv-calendar",
      "calendarButtonVariant": "actionBar",
      "clearButtonVariant": "actionBar",
      "clearIcon": "fak fa-lv-cancel"
    },
    "attributeTableTimestampEditor": {
      "calendarIcon": "fak fa-lv-calendar",
      "calendarButtonVariant": "link",
      "clearButtonVariant": "link"
    }
  }
}